import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

interface PageHeaderProps {
  breadcrumb?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ breadcrumb, title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <div className={cn("mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between", className)}>
      <div className="min-w-0">
        {breadcrumb ? <div className="mb-1 text-xs text-foreground-500">{breadcrumb}</div> : null}
        <h1 className="flex items-center gap-2 text-lg font-semibold text-foreground-950">
          <span className="truncate">{title}</span>
        </h1>
        {subtitle ? <p className="mt-0.5 text-sm text-foreground-500">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-none flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function BreadcrumbItem({ label, to, isLast }: { label: string; to?: string; isLast?: boolean }) {
  if (isLast) {
    return <span className="text-foreground-700">{label}</span>;
  }
  return (
    <>
      <a href={to ?? "#"} className="text-foreground-400 hover:text-foreground-700 hover:underline">
        {label}
      </a>
      <span className="text-foreground-300">/</span>
    </>
  );
}